import { postToApiPath } from '../shared/utilities/apiClient';
import { BulkFormActionResult } from '../types/bulkFormActionResult';

export const bulkUpgradeForms = (
    formIds: string[],
    toastText?: {
        onPendingText?: string;
    }
) =>
    postToApiPath<BulkFormActionResult>(
        'testapp/forms/bulk/upgrade',
        { formIds },
        {
            headers: {
                'Toast-Pending-Text': toastText?.onPendingText,
                SkipSuccessToast: true,
            },
        }
    )
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
